import { IAccountRepository } from '../entities/IAccountRepository';
import { IAccountService } from '../entities/IAccountService';
import { AccountList, AccountDetails, AccountCertificate } from '../entities';

export class AccountServiceImpl implements IAccountService {
  itemRepo: IAccountRepository;

  constructor(ir: IAccountRepository) {
    this.itemRepo = ir;

    this.GetCustomerAccounts = this.GetCustomerAccounts.bind(this);
    this.GetCustomerAccountDetails = this.GetCustomerAccountDetails.bind(this);
    this.GetAccountCertificate = this.GetAccountCertificate.bind(this);
  }

  // TODO: add correct data types
  GetCustomerAccounts(data: any): Promise<AccountList> {
    return this.itemRepo.GetCustomerAccounts(data?.customerId, data?.retrieveSummary);
  }

  // TODO: add correct data types
  GetCustomerAccountDetails(data: any): Promise<AccountDetails> {
    return this.itemRepo.GetCustomerAccountDetails(data?.customerId, data?.accountId);
  }

  GetAccountCertificate(data: any): Promise<AccountCertificate> {
    return this.itemRepo.GetAccountCertificate(data?.accountId);
  }
}
